// Dependencies
import {connect} from 'react-redux';
import radium from 'radium';
import PriceLevel from './Pricelevel.jsx';

interface PriceLevelListProps {
	standardPriceLevel?: any,
	reducedPriceLevels?: any,
	ticketsAvailable: number,
	categoryUuid?: string,
	ticketsAvailableMap?: any
}

function PriceLevelList(props: PriceLevelListProps) {
	const sortedReducedPls = props.reducedPriceLevels.sort((a: any, b: any) => {
		if ((!a || !b) || ((a.pos === null) && (b.pos === null))) {
			return 0;
		}
		return a.pos > b.pos ? 1 : -1;
	})
	const priceLevels = [props.standardPriceLevel, ...sortedReducedPls].filter(el => el != null); // remove hole, null, and undefined and sort by position
	const style = {};
	return priceLevels.length > 0 ?
		(
			<ul style={style}>
				{priceLevels.map((priceLevel) =>
					(
						!priceLevel.hideOnline ?
							<li key={priceLevel.priceLevelUuid}>
								<PriceLevel
									categoryUuid={props.categoryUuid}
									pricelevel={priceLevel}
									ticketsAvailable={props.ticketsAvailableMap[priceLevel.priceLevelUuid]}
								/>
							</li> : null
					)
				)}
			</ul>
		) : null;
}

const PriceLevelListRadium = radium(PriceLevelList);
// ------------------------------
// Store Connection
// ------------------------------

const calcTicketsAvailableMap = (state: any, ownProps: any) => {
	const priceLevelUuids = [
		ownProps.standardPriceLevel ? ownProps.standardPriceLevel.priceLevelUuid : null,
		...ownProps.reducedPriceLevels.map((pl:any) => pl.priceLevelUuid),
	].filter(el => el != null);
	
	const availableMap: Record<any, any> = {};
	for (const uuid of priceLevelUuids) {
		const selected = state.eventPage.amountOfTicketsInCart[uuid] || 0;
		availableMap[uuid] = (ownProps.ticketsAvailable + selected);
	}
	return availableMap;
};


const mapStateToProps = (state:any, ownProps:any) => ({
	ticketsAvailableMap: calcTicketsAvailableMap(state, ownProps),
});


export default connect(
	mapStateToProps,
)(PriceLevelListRadium);

